import React, { FC, useEffect, useRef, useState } from 'react'

import fireChat from 'fireChat'
import useEvent from 'Hooks/useEvent'
import useMounted from 'Hooks/useMounted'
import { useChatAuth } from 'Pages/Chat/AuthProvider'

import BlinkingDots from 'Components/BlinkingDots'

interface Props {
  chatId: string
}

const Typing: FC<Props> = ({ chatId }) => {
  const { uid } = useChatAuth()
  const [timestamp, setTimestamp] = useState<number>(0)
  const [inProgress, setInProgress] = useState(true)
  const isMounted = useMounted()
  const typingRef = useRef<ReturnType<typeof setTimeout>>()

  const subscribeOnTyping = useEvent(() => {
    return fireChat.subscribeOnTyping(chatId, (typings) => {
      if (!isMounted()) return

      let timestamp = 0
      typings.forEach((typing) => {
        if (typing.memberId == uid) return

        const time = typing.timestamp.toDate().getTime()
        if (time > timestamp) timestamp = time
      })

      setTimestamp(timestamp)
    })
  })

  useEffect(() => {
    if (!uid) return

    return subscribeOnTyping()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uid])

  useEffect(() => {
    const now = Date.now()
    const tolerance = 3000
    let timer: ReturnType<typeof setTimeout>
    if (now > timestamp && timestamp > now - tolerance) {
      setInProgress(true)

      timer = setTimeout(() => {
        if (!isMounted()) return

        setInProgress(false)
      }, tolerance)
    } else {
      setInProgress(false)
    }

    return () => clearTimeout(timer)
  }, [timestamp, isMounted])

  useEffect(() => () => clearTimeout(typingRef.current), [])

  return inProgress ? <BlinkingDots>We&apos;re typing</BlinkingDots> : null
}

export default Typing
